<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="contractLoader">
		</AccountDetailComponent>
		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Contratos de Monitoreo</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="contractLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>

								<div v-if="!contractLoader && contractsList && contractsList.length > 0" class="ml-2">
									<b-button variant="link"
											  class="text-success"
											  @click="exportToExcel"
											  v-b-tooltip.hover title="Descargar listado en Formato Excel">
										<i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body class="table-responsive">
						<b-table :items="contractsList"
								 :current-page="currentPageContract"
								 :per-page="perPage"
								 :fields="contractTableFields"
								 :busy="contractLoader"
								 show-empty
								 empty-filtered-text="No hay contratos de mantenimiento disponibles"
								 empty-text="No hay contratos de mantenimiento disponibles"
								 head-variant="light">
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
							<div slot="CreatedOn" slot-scope="item">
								{{item.item.CreatedOn | dateFormat}}
							</div>
							<div slot="ExpiresOn" slot-scope="item">
								{{item.item.ExpiresOn | dateFormat}}
							</div>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalContractsRows > perPage">
							<b-pagination
								:total-rows="totalContractsRows"
								:per-page="perPage"
								v-model="currentPageContract"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from "../components/AccountDetailComponent";
	import GoBackComponent from "../components/GoBackComponent";
	import XLSX from "xlsx";

	export default {
		name: "ContractList",
		components: {
			GoBackComponent,
			AccountDetailComponent,
		},
		data: function () {
			return {
				perPage: 10,
				currentPageContract: 1,
				contractTableFields: {
					ContractNumber: {
						label: 'Número de Contrato'
					},
					Name: {
						label: 'Descripción'
					},
					ContractType: {
						label: 'Tipo de Contrato'
					},
					CreatedOn: {
						label: 'Fecha de Creación'
					},
					ExpiresOn: {
						label: 'Fecha de Expiración'
					}
				},
				accountSelected: '',
				contractsList: [],
				contractLoader: false
			}
		},
		mounted() {
			if (this.$store.getters.accountSelected !== '') {
				this.accountSelected = this.$store.state.accountSelected;
				this.getContracts();
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			getContracts() {
				this.contractLoader = true;
				this.$store.dispatch('getContracts')
					.then((Contracts) => {
						this.contractsList = Contracts;
					})
					.finally(() => {
						this.contractLoader = false;
					});
			},
			exportToExcel() {
				let newList = this.contractsList.map(function (obj) {
					return {
						'Número de Contrato': obj.ContractNumber,
						'Descripción': obj.Name,
						'Tipo de Contrato': obj.ContractType,
						'Fecha de Creación': obj.CreatedOn,
						'Fecha de Expiración': obj.ExpiresOn,
					};
				});

				let data = XLSX.utils.json_to_sheet(newList);
				const workbook = XLSX.utils.book_new();
				const filename = 'contratos-de-monitoreo';
				XLSX.utils.book_append_sheet(workbook, data, filename);
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			}
		},
		computed: {
			totalContractsRows: function () {
				return this.contractsList.length;
			}
		}
	}
</script>

<style scoped>

</style>
